/* global appData */
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VueRouter from 'vue-router';
import store from './store';
import { mapState } from 'vuex';
import VueShave from 'vue-shave';
import VueBgSrc from 'vue-bg-src';
import VueYouTubeEmbed from 'vue-youtube-embed';
import { mixin as clickaway } from 'vue-clickaway';

import QdLoadingScreen from './components/loading-screen/loading-screen.js';
import QdSidebar from './components/sidebar/sidebar.js';
import FixedWidget from './components/fixed-widget/fixed-widget.js';
import TypeMarket from './components/type-market/type-market.js';

import { router } from './router';
import template from './app.vhtml';

sync(store, router);

Vue.use(VueRouter);
Vue.use(VueShave);
Vue.use(VueBgSrc, {
    mediaQueries: {
        md: '(min-width: 350px)',
        lg: '(min-width: 736px)',
        xl: '(min-width: 1000px)',
    }
});
Vue.use(VueYouTubeEmbed);

export const App = new Vue({
    el: '#app',
    store,
    components: {
        QdLoadingScreen,
        QdSidebar,
        FixedWidget,
        TypeMarket,
    },
    template: template,
    router: router,
    data: () => ({
        appLoaded: false,
    }),
    mixins: [clickaway],
    computed: {
        layoutInnerClasses: vm => ['l-app__inner', {
            'l-app__inner--sidebar': vm.showSidebar,
            'l-app__inner--sidebar-right': vm.paginationOutOfView == 'right',
            'l-app__inner--align-top': vm.paginationIsFullHeight,
        }],
        layoutSidebarClasses: vm => ['l-app__sidebar', {
            'l-app__sidebar--right': vm.paginationOutOfView == 'right',
            'l-app__sidebar--align-border-right': vm.appOverviewIsOpen,
            'l-app__sidebar--is-navigating': vm.isNavigating,
        }],
        layoutPaginationClasses: vm => ['l-app__pagination', {
            'l-app__pagination--full-height': vm.paginationIsFullHeight,
            'l-app__pagination--full-width': vm.paginationShowNav,
            'l-app__pagination--out-of-view-right': vm.paginationOutOfView == 'right',
        }],
        layoutFixedWidgetClasses: vm => ['l-app__fixed-widget', {
            'l-app__fixed-widget--further-up': !vm.paginationIsFullHeight,
            'l-app__fixed-widget--hidden': vm.paginationOutOfView == 'right' && vm.paginationIsFullHeight || vm.appOverviewIsOpen && vm.paginationIsFullHeight,
            'l-app__fixed-widget--further-up-hidden': vm.paginationOutOfView == 'right' && !vm.paginationIsFullHeight || vm.appOverviewIsOpen && !vm.paginationIsFullHeight,
            'l-app__fixed-widget--fixed': vm.fixedWidgetIsFixed,
        }],
        ...mapState({
            paginationShowNav: state => state.pagination.showNav,
            paginationOutOfView: state => state.pagination.outOfViewPos,
            paginationIsFullHeight: state => state.pagination.fullHeight,
            appOverviewIsOpen: state => state.apps.isOpen,
            sidebarPos: state => state.sidebar.sidebarPos,
            showSidebar: state => state.sidebar.showSidebar,
            sidebarStuckToTopMobile: state => state.sidebar.stuckToTopMobile,
            showPagination: state => state.pagination.showPagination,
            showFixedWidget: state => state.fixedWidget.showFixedWidget,
            fixedWidgetIsFixed: state => state.fixedWidget.isFixed,
            fixedWidgetIsPrioritiezed: state => !state.content.showIndexLocation,
            showAppSub: state => state.pages.showAppSub,
            isNavigating: state => state.pages.isNavigating,
            scrollPosition: state => state.pages.scrollPosition,
        }),
    },
    watch: {
        appLoaded() {
            // this.appOverviewIsOpen ? this.$store.dispatch('pages/setScrollPosition') : this.$store.dispatch('pages/removeScrollPosition');
        },
        appOverviewIsOpen() {
            // this. appOverviewIsOpen ? this.$store.dispatch('pages/setScrollPosition') : this.$store.dispatch('pages/removeScrollPosition');
        },
        isNavigating() {
            if (this.isNavigating && this.appOverviewIsOpen) this.$store.commit('apps/updateData', {
                name: 'isOpen',
                value: false,
            });
        },
    },
    mounted() {
        const vm = this;
        window.onload = function () {
            setTimeout(() => {
                vm.appLoaded = true;
            }, 1500);
        };
        this.$store.dispatch('apps/initializeData');
        // this.$store.dispatch('appsData/initializeData');
        this.$store.commit('pagination/updateData', {
            name: 'forwardLoop',
            value: false,
        });
    },
});



// WEBPACK FOOTER //
// ./assets/_js/app.js